import { LiveSearchMetadataView } from '../view/LiveSearchMetadataView';
import { templateLiveSearchMetadata } from '../view/template';
import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { LiveSearchMetadataWebComponent } from '..';
import { ButtonEvents } from '../../../../ui/gzButton/types';

export class LiveSearchMetadataController extends BaseWebComponentController {
  public component: LiveSearchMetadataWebComponent;
  public view: LiveSearchMetadataView;
  public viewConstructor: typeof LiveSearchMetadataView;

  constructor(component: LiveSearchMetadataWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: LiveSearchMetadataView,
      viewTemplate: templateLiveSearchMetadata,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$metadataHeader,
        event: ButtonEvents.CLICK,
        callback: this.handleMetadataViewMoreDivClick,
      },
    ];
  }

  handleMetadataViewMoreDivClick(): void {
    this.view.showMetadataPopup(this.component.getQueryExecution());
  }

  public setPageTitle(title: string): void {
    this.view.pageTitle = title;
  }

  async render(): Promise<void> {
    this.view.render({
      queryExecution: this.component.getQueryExecution(),
    });
  }
}
